import theme from '../../../lib/theme';

const { layouts } = theme;

export default () => ({
  container: {
    ...layouts.spacedRow('xs'),
  },
});
